import  { useEffect } from "react";
let placesService;
let geocoder;
const GoogleMap = () => {

  useEffect(() => {
    const googleScript = document.createElement("script");
    googleScript.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places,geocoding`;
    googleScript.async = true;
    googleScript.defer = true;

    document.body.appendChild(googleScript);

    googleScript.addEventListener("load", () => {
    placesService = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
    geocoder = new window.google.maps.Geocoder();

    });

    return () => {
    document.body.removeChild(googleScript);
     };
  }, []);

  return null; 
};
export {placesService,geocoder }; // Export placesService and geocoder

export default GoogleMap;
